import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../lib/chalkApi";
import { ChalkActionButton } from "../components/chalk/primitives";

// Parent-facing join link: /join/team?code=ABCD-1234
export default function JoinTeam() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const code = (params.get("code") || sessionStorage.getItem("chalk_join_code") || "").slice(0, 12);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (code) sessionStorage.setItem("chalk_join_code", code);
  }, [code]);
  useEffect(() => {
    if (user && (sessionStorage.getItem("chalkos.afterLogin") || "").startsWith("/join/team")) sessionStorage.removeItem("chalkos.afterLogin");
  }, [user]);

  async function join() {
    setBusy(true);
    try {
      await api.joinByCode(code);
      sessionStorage.removeItem("chalk_join_code");
      toast.success("You're on the team.");
      navigate("/app", { replace: true });
    } catch (e) {
      toast.error(e.message);
      setBusy(false);
    }
  }

  function auth(path) {
    sessionStorage.setItem("chalkos.afterLogin", `/join/team?code=${encodeURIComponent(code)}`);
    navigate(path);
  }

  return (
    <div className="chalk-min-h-screen chalk-on-dark" style={{ background: "var(--chalk-board)", color: "var(--chalk-white)", padding: "56px 22px" }}>
      <div style={{ maxWidth: 440, margin: "0 auto" }} data-testid="join-team-page">
        <div style={{ fontSize: 11, letterSpacing: "0.12em", textTransform: "uppercase", opacity: 0.7 }}>ChalkOS</div>
        <h1 style={{ fontFamily: "var(--font-display, 'Bebas Neue', sans-serif)", fontSize: 40, margin: "8px 0" }}>Join your team</h1>
        <p style={{ fontSize: 15, opacity: 0.85, lineHeight: 1.5 }}>
          Your coach uses ChalkOS for the schedule, changes, and team messages. Team code{" "}
          <b data-testid="join-team-code">{code || "missing"}</b>.
        </p>
        {loading ? null : user ? (
          <ChalkActionButton testId="join-team-btn" label="Join the team" loading={busy} onClick={join} disabled={!code} />
        ) : (
          <div style={{ display: "grid", gap: 10, marginTop: 16 }}>
            <ChalkActionButton testId="join-team-signup" label="Create a free parent account" onClick={() => auth("/signup?role=guardian")} />
            <ChalkActionButton testId="join-team-signin" variant="ghost" label="I already have an account" onClick={() => auth("/login")} />
          </div>
        )}
      </div>
    </div>
  );
}
